import React from 'react'

import { TypeVariationContainerAuthAndDeviceTypeCta } from '../../lib/types'
import { ContentProps, ContentRenderer } from '../renderer'
import { useGetAuthAndDeviceTypeCta } from '../../lib/hooks/auth-and-device-type-cta'

export const AuthAndDeviceTypeCtaVariationContainer: React.FC<
  ContentProps<TypeVariationContainerAuthAndDeviceTypeCta>
> = (props) => {
  const { getAuthAndDeviceTypeCta } = useGetAuthAndDeviceTypeCta()

  return <ContentRenderer structure={getAuthAndDeviceTypeCta(props.structure)} />
}
